import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { API } from "../../../App";
import { GraduationCap } from "lucide-react";

// Alunos da escola que já têm turma mas ainda não têm ficha na DI. Sem a ficha, o aluno não aparece na lista de pilotos.
const erro = (e) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Não foi possível criar a ficha.");

export default function StudentsWithoutPilotCard() {
  const [alunos, setAlunos] = useState([]);
  const [aGravar, setAGravar] = useState(null);

  const carregar = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/di/students-available`, { withCredentials: true });
      setAlunos(data || []);
    } catch {
      setAlunos([]);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const criarFicha = async (aluno) => {
    setAGravar(aluno.user_id);
    try {
      await axios.post(`${API}/di/pilots/from-student/${aluno.user_id}`, {}, { withCredentials: true });
      toast.success(`Ficha criada para ${aluno.name || aluno.email}. Carrega os documentos em Documentos anexos.`);
      carregar();
    } catch (e) {
      toast.error(erro(e));
    } finally {
      setAGravar(null);
    }
  };

  if (alunos.length === 0) return null;

  return (
    <Card className="instrument-panel" data-testid="di-alunos-sem-ficha">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2 text-emerald-300">
          <GraduationCap className="w-5 h-5" /> Alunos com turma sem ficha de piloto ({alunos.length})
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-xs">
        {alunos.map((a) => (
          <div key={a.user_id} className="border-t border-slate-800 pt-2 flex flex-wrap items-center justify-between gap-2" data-testid="di-aluno-sem-ficha">
            <span className="text-slate-200">
              <span className="font-medium">{a.name || a.email}</span>
              {a.email && <span className="text-slate-400"> · {a.email}</span>}
            </span>
            <Button size="sm" onClick={() => criarFicha(a)} disabled={aGravar === a.user_id} data-testid="di-aluno-criar-ficha">
              Criar ficha de aluno
            </Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
